<template>
    <div class="GameListPP"  v-if="list2">

        <div  class="box-list-game-type">
            <ul class="nav nav-tabs tab-cst tab-style" id="myTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="home-tab" data-toggle="tab" href="#tab-all_pp" role="tab"
                       aria-controls="home" aria-selected="true">ALL</a>
                </li>
                <li class="nav-item" v-if="service_list.includes('kp')">
                    <a class="nav-link" id="profile-tab" data-toggle="tab" href="#tab-prag_pp" role="tab"
                       aria-controls="profile" aria-selected="false">KP</a>
                </li>
                <li class="nav-item"  v-if="service_list.includes('queenmaker')">
                    <a class="nav-link" id="contact-tab" data-toggle="tab" href="#tab-cq_pp" role="tab"
                       aria-controls="contact" aria-selected="false">QueenMaker</a>
                </li>
            </ul>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="tab-all_pp" role="tabpanel" aria-labelledby="home-tab">
                    <div class="wrapper-box-list">
                        <div class="box-games-type"  v-if="service_list.includes('kp')">
                            <h4>KP</h4>
                            <div class="content-lists content-kp-list">
                                <div v-for="(game,key) of list2.p2p[0]" :key="key" class="box-s-list" @click="openGame2(game,'kp')">

                                    <div class="btnPlay-s-list"></div>
                                    <img :src="game.img"/>
                                    <span>{{game.name}}</span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                        <div class="box-games-type"  v-if="service_list.includes('queenmaker')">
                            <h4>QueenMaker</h4>
                            <div class="content-list-slot">
                                <div v-for="(game,key) of list2.p2p[2]" :key="key" class="content-list-slot-row">
                                    <div class="box-s-list" @click="openGame2(game[0],'queenmaker')"> 
                                        <div class="btnPlay-s-list"></div>
                                        <img :src="game[0].img"/>
                                        <span>{{game[0].name}}</span>
                                        </div>
                                    
                                    <div v-if="game.length==2 && game[1]!=null" class="box-s-list" @click="openGame2(game[1],'queenmaker')"> 
                                        <div class="btnPlay-s-list"></div>
                                        <img :src="game[1].img"/>
                                        <span>{{game[1].name}}</span>
                                    </div>
                                </div>

                                    
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="tab-prag_pp" role="tabpanel" aria-labelledby="profile-tab">

                    <div class="wrapper-box-list">
                        <div class="box-games-type">
                            <div class="content-lists content-kp-list">
                                <div v-for="(game,key) of list2.p2p[0]" :key="key" class="box-s-list" @click="openGame2(game,'kp')">
                                    
                                    <div class="btnPlay-s-list"></div>
                                    <img :src="game.img"/>
                                    <span>{{game.name}}</span>
                                </div>
                            </div>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="tab-cq_pp" role="tabpanel" aria-labelledby="profile-tab">
                    <div class="wrapper-box-list">
                        <div class="box-games-type  box-games-type-2">
                            <div class="content-lists">
                               

                                    <div v-for="(game,key) of list2.p2p[1]" :key="key" class="box-s-list" @click="openGame2(game,'queenmaker')">
                                    
                                    <div class="btnPlay-s-list"></div>
                                    <img :src="game.img"/>
                                    <span>{{game.name}}</span>
                                </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="wrapbox-list-games" style="display: none;">
            <div
                    v-for="(game, key) of games"
                    :key="key"
                    class="box-list-games">
                <div class="box-icon-games"><img :src="calIcon(key)"></div>
                <div class="box-detail-games">
                    <h4>{{game.title}}</h4>
                    <div class="info-games">
                        {{game.description}} |
                        <strong class="text-info">
                            {{getPlayingCount() | numberFormat}} คนกำลังเล่น
                        </strong>
                    </div>
                </div>
                <div class="box-btn">
                    <button @click="openGame(game)" class="btn btn-block btn-sm btn-info">เข้าสู่เกมส์</button>
                </div>
            </div>
        </div>


    </div>
</template>
<script>

    import axiosWrapper from '@/axiosWrapper'
    import randomBetween from '@/lib/randomBetween'
    import store from '@/store'
    import UserMixin from '@/mixins/UserMixin'

    export default {
        name: 'GameList',
        mixins: [UserMixin],
        data() {
            return {
                games: [],
                icons: [
                    '/images/icon/set-icon/icon-casino.png',
                    '/images/icon/set-icon/icon-slot.png',
                    '/images/icon/set-icon/icon-casino.png',
                    '/images/icon/set-icon/icon-football.png',
                    '/images/icon/set-icon/icon-fishing.png',
                    '/images/icon/set-icon/icon-lotto.png',
                    '/images/icon/set-icon/icon-roulette.png',
                    '/images/icon/set-icon/icon-case.png',
                ],
                selectedBrand: 'queenmaker',
                list2:null,
                service_list : `${process.env.VUE_APP_PES_SERVICE_LIST}`.split(","),
            }
        },
        computed: {
            is_member() {
                return store.state.is_member
            },
            pes_profile() {
                return store.state.pes_profile
            },
            token() {
                return this.pes_profile.token
            },
            getAllGameList(){
                return store.state.allGameList;
            },
            appImageProfile(){
                return store.state.appInfo.app_image_profile
            },
        },
        methods: {
            async getGameList(brand = 'queenmaker') {

                const res = await axiosWrapper({
                    method: 'post',
                    url: `${this.envDomains.VUE_APP_API}/api/game/list`,
                    data: {
                        brand
                    }
                })

                if (!res.data.success) {
                    this.$alert(res.data.message, 'แจ้งเตือน', {
                        confirmButtonText: 'ตกลง',
                        customClass: 'custom-message-box'
                    })
                    return
                }

                return res.data.data
            },
            calIcon(key) {
                return this.icons[key % this.icons.length]
            },
            getPlayingCount() {
                return randomBetween(111, 1111)
            },
            openGame(game) {

                if (!this.is_member) {
                    this.notifyToSignUp('เพื่อเล่น')
                    return
                }

                const baseUrl = `/game/casinoonline/sa_sexy_redirect.php?service=${this.selectedBrand}`

                let query = ''
                if (this.selectedBrand === 'queenmaker') {
                    query = `&gpcode=${game.gpcode}&gcode=${game.gcode}`
                } else if (this.selectedBrand === 'kp') {
                    query = `&gameId=${game.gameId}`
                } else if (this.selectedBrand === 'cqgame') {
                    query = `&gamehall=${game.gamehall}&gamecode=${game.gamecode}`
                }
                if(this.appImageProfile){
                    query = query+'&logo_img='+this.appImageProfile
                }

                const url = `${this.envDomains.VUE_APP_PES_BASE_URL}${baseUrl}${query}&token=${this.token}`
                window.open(url, '_blank')
            },
            openGame2(game,service){
                if (!this.is_member) {
                    this.notifyToSignUp('เพื่อเล่น')
                    return
                }
                var params =[
                    
                ];
                
                if(service=='pragmatic'){
                    params.push('code='+game.gameId);
                }else if(service=='sa'){
                    params.push('code='+game.code);
                }
                if(this.appImageProfile){
                    params.push('logo_img='+this.appImageProfile);
                }
                const url = `${this.envDomains.VUE_APP_PES_BASE_URL}/game/casinoonline/sa_sexy_redirect.php?mode=mobile&service=${service}&${params.join('&')}&token=${this.token}`
                if(service=='sa'){
                    window.location.href=url
                }else{
                    this.$router.push({ name: 'GamePlayFrame', "query": { 'url': encodeURIComponent(url) } })
                }
                
                
            },
            getLinkGameP2P(type,game){
                if(type=='kp'){
                    return `${this.envDomains.VUE_APP_PES_BASE_URL}/game/casinoonline/sa_sexy_redirect.php?mode=&by=&service=kp&gameId=`+game+`&token=`+this.token+(this.appImageProfile?('&logo_img='+this.appImageProfile):'');

                }else if(type=='queenmaker'){
                    return `${this.envDomains.VUE_APP_PES_BASE_URL}/game/casinoonline/sa_sexy_redirect.php?mode=&by=&service=queenmaker&gpcode=KMQM&gcode=`+game+`&token=`+this.token+(this.appImageProfile?('&logo_img='+this.appImageProfile):'');

                }
            }
        },
        async mounted() {
            var list2=this.getAllGameList;
            var self = this;
            if(list2==null){
                var clearInv=setInterval(function(){
                    var list2 = self.getAllGameList;

                    if( list2!=null){
                        // console.log('success');
                        var p2pList=list2.p2p[1];
                        var new_list =[];
                        for(var i2=0;i2<p2pList.length;i2=i2+2){
                            new_list.push([p2pList[i2],p2pList[i2+1]]);

                        }
                        list2.p2p[2] = new_list;
                        self.list2 = list2;
                        // console.log(self.list2.p2p);
                        clearInterval(clearInv);

                    }

                },500)
            }else{
                var p2pList= list2.p2p[1];
                var new_list =[];
                for(var i=0;i<p2pList.length;i=i+2){
                    new_list.push([p2pList[i],p2pList[i+1]]);

                }
                list2.p2p[2] = new_list;
                this.list2 = list2;
            }
        },
    }
</script>
<style scoped>

</style>